import { distinctUntilChanged } from 'rxjs/operators';
import { FEEDBACK_TYPES } from './email-alerts-constants';
class EmailAlertsTracking {
    constructor() {}


    addSectionSubscription(feedback = null) {
        let trackingCode = null;
        if (feedback == FEEDBACK_TYPES.SUCCESS || feedback == FEEDBACK_TYPES.NEW) {
            trackingCode = 'alrt-clmn_newsub';
        } else if (subscriptionFeedback == FEEDBACK_TYPES.EXISTING) {
            trackingCode = 'alrt-clmn_subd';
        }
        if (trackingCode != null) {
            window.wmdPageLink(trackingCode);
        }
    }

    addConceptSubscription(feedback = null) {
        let trackingCode = null;
        if (feedback == FEEDBACK_TYPES.SUCCESS || feedback == FEEDBACK_TYPES.NEW) {
            trackingCode = 'alrt-topc_newsub';
        } else if (feedback == FEEDBACK_TYPES.EXISTING) {
            trackingCode = 'alrt-topc_subd';
        }
        if (trackingCode != null) {
            window.wmdPageLink(trackingCode);
        }
    }

}

export { EmailAlertsTracking }